export class RavenToSentryAdapter {
    constructor(ravenClient) {
        this.ravenClient = ravenClient;
    }
    captureException(exception, options) {
        if (options === null || options === void 0 ? void 0 : options.contexts) {
            options = Object.assign(Object.assign({}, options), { extra: options.contexts });
        }
        this.ravenClient.captureException(exception, options);
        return this.ravenClient.lastEventId();
    }
    captureMessage(message, options) {
        if (options === null || options === void 0 ? void 0 : options.contexts) {
            options = Object.assign(Object.assign({}, options), { extra: options.contexts });
        }
        this.ravenClient.captureMessage(message, options);
        return this.ravenClient.lastEventId();
    }
    addBreadcrumb(breadcrumb) {
        return this.ravenClient.captureBreadcrumb(breadcrumb);
    }
}
//# sourceMappingURL=RavenToSentryAdapter.js.map